/*
 * @Author: zch
 * @Date: 2022-07-21 10:17:18
 * @LastEditors: 黄昱森
 * @LastEditTime: 2023-05-08 15:37:46
 * @Description: 
 */
import Utils from '@/utils/utils';
import Constants from '@/constants/constants.js';
// import store from '@/store';
/**
 * 权限指令 */
export default {
  inserted: function (el, binding, vnode) {
    const permissionKey = binding.value;
    const permissionConfig = Utils.Session.getObject('btnPermissions');
    try {
      const filter_list = ['delete', 'add', 'edit', 'save', 'stash', 'set'];
      const ignore_list = ['messageStructure:set'];
      //忽略的列表

      const keys = permissionKey?.split(":") || []
      const type = keys[keys.length - 1]
      // const { sysVersionStat } = Utils.Local.getObject('lastDecision') || {}
      // if (sysVersionStat === '2' && filter_list.find(f => f === type)) {//表示系统已发布
      //     const btn_list = Utils.Local.getObject('plat_btn_list');
      //     if (!btn_list.find(t => t === permissionKey) && !ignore_list.find(t => t === permissionKey)) {
      //         disableButton(el);
      //         return;
      //     }
      // }
      const btn_list = Utils.Local.getObject('plat_btn_list');
      if (btn_list.find(t => t === permissionKey) && !ignore_list.find(t => t === permissionKey)) {

        disableButton(el);
        return;
      }
      const currentButtonStatus = Utils.get(permissionKey, permissionConfig);
      if (currentButtonStatus === Constants.PermissionStatus.Enabled) {
        return;
      } else if (currentButtonStatus === Constants.PermissionStatus.Disabled) {
        disableButton(el);
      } else {
        let isAdmin = Utils.Local.getObject('lastDecision')?.isAdmin;
        if (isAdmin) {
          return;
        }
        removeButton(el);
        // return;
      }
    } catch (error) {
      return;
    }
  }
};

function removeButton(el) {
  el.parentNode.removeChild(el);
}

function disableButton(el) {
  el.disabled = true;
  el.style.cursor = 'not-allowed';
  el.classList.add('is-disabled');
}
